import { ReactElement } from 'react';

import { ICategory } from '@Hotels-at-Home/hah-fe-core/dist/types/category';
import get from 'lodash/get';
import classNames from 'classnames';

interface IProps {
  category: ICategory;
}

const CategorySEO = ({ category }: IProps): ReactElement => {
  console.log('category', category);
  const seoCopy = category.seo_copy || [];

  const description = category.description || '';

  if (!description) {
    return null;
  }

  return (
    <section className={classNames('seo')}>
      <div className="seo-stack">
        <p>{description}</p>
      </div>
    </section>
  );
};

export default CategorySEO;
